import {
  SoftwareManagementDashboardSoftwareCost,
  SoftwareManagementMonthlySoftwareCost,
} from 'generated/resources/graphql'
import moment from 'moment'

import { fromCents } from 'modules/core/lib/formatCurrencyUtils'

import { monthFromDate, monthsInYear } from './dates'

export const monthlySoftwareCosts = (softwareCosts: SoftwareManagementMonthlySoftwareCost[]) => {
  return monthsInYear().map((month) => {
    const { costInCents } = softwareCosts.find((cost) => cost.monthlyIndexedDate == month) || {}

    return {
      x: moment(month).toDate(),
      y: costInCents ? fromCents(costInCents) : null,
    }
  })
}

export const monthlyDashboardCosts = (
  dashboardCosts: SoftwareManagementDashboardSoftwareCost[]
) => {
  return monthsInYear().map((month) => {
    const { monthlyCostInCents, seatCostInCents } =
      dashboardCosts.find((cost) => cost.monthlyIndexedDate == month) || {}

    return {
      month: moment(month).toDate(),
      appCost: monthlyCostInCents ? fromCents(monthlyCostInCents) : null,
      seatCost: seatCostInCents ? fromCents(seatCostInCents) : null,
    }
  })
}

export const softwareCostForMonth = (
  softwareCosts: SoftwareManagementMonthlySoftwareCost[],
  month: number
) => {
  const costForMonth = softwareCosts.find((cost) => monthFromDate(cost.monthlyIndexedDate) == month)

  return costForMonth?.costInCents || 0
}

export const dashboardCostForMonth = (
  dashboardCosts: SoftwareManagementDashboardSoftwareCost[],
  month: number
) => {
  const costForMonth = dashboardCosts.find(
    (cost) => monthFromDate(cost.monthlyIndexedDate) == month
  )

  return costForMonth?.monthlyCostInCents || 0
}
